import React, { ReactElement, useMemo } from 'react'
import styles from './StudyMaterialsGuidePage.module.scss'
import { Overview } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/Overview'
import { ColorMap, getJepColor } from '@/components/static/ui/consts'
import { StudyGuideBannerLink } from '@/components/static/StudyMaterialsGuidePage/GuideComponents/StudyGuideBannerLink/StudyGuideBannerLink'
import { ExcitedOwl } from '@/components/static/images/owlBranding/excitedOwl'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import Link from 'next/link'
import {
    GenericButton,
    GenericButtonType,
} from '@/components/static/ui/Button/GenericButton/GenericButton'
import { useShouldStackImagesAndBullets } from '@/hooks/useShouldStackImagesAndBullets'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'
import { getAbbreviationName } from '@/components/static/StudyMaterialsGuidePage/utils'

export const StudyMaterialsGuidePage: React.FC<
    BasePageProps & { isLoggedIn: boolean }
> = (props): ReactElement => {
    const shouldStackImagesAndBullets = useShouldStackImagesAndBullets()
    const color = useMemo((): ColorMap => {
        return getJepColor(props.courseConfigType)
    }, [props.courseConfigType])
    return (
        <div
            className={`${styles.studyMaterialsGuidePageBackground} ${
                props.isLoggedIn ? styles.loggedIn : styles.notLoggedIn
            }`}
        >
            <div className={styles.studyMaterialsGuidePage}>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <div className={styles.innerTitleContainer}>
                            <ExcitedOwl priority={false} />
                        </div>
                        <div className={styles.innerTitleContainer}>
                            Get started with{' '}
                            <span className={styles.emphasis}>
                                {getAbbreviationName(props.courseConfigType)}
                            </span>
                        </div>
                        {props.courseConfigType ===
                            CourseConfigType.fsaHealth && (
                            <div
                                className={styles.innerTitleContainer}
                                style={{ marginLeft: 12 }}
                            >
                                <Link
                                    href={
                                        UiLayoutConstant.EXAM_CHANGE_GUIDE_PAGE
                                    }
                                >
                                    <GenericButton
                                        type={
                                            GenericButtonType.greenNoBackground
                                        }
                                        text={'Fall 2026 Exam Update Guide'}
                                        onClick={null}
                                    />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
                <div className={styles.guideComponents}>
                    <Overview
                        shouldStackImagesAndBullets={
                            shouldStackImagesAndBullets
                        }
                        isLoggedIn={props.isLoggedIn}
                        {...props}
                    />
                    <div className={styles.bannerLinkContainer}>
                        <StudyGuideBannerLink
                            title={'PHILOSOPHY'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                        <StudyGuideBannerLink
                            title={'NOTECARDS'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                        <StudyGuideBannerLink
                            title={'PRACTICE QUESTIONS'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                        <StudyGuideBannerLink
                            title={'OUTLINES'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                        <StudyGuideBannerLink
                            title={'OTHER'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                        <StudyGuideBannerLink
                            title={'GENERAL TIPS'}
                            disabled={false}
                            courseConfigType={props.courseConfigType}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
